import {Contact} from "../types.ts";
import {Badge, Text} from "@mantine/core";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {DataTableColumn} from "mantine-datatable";
import {NavLink} from "react-router-dom";

export const useContactsTableColumns = () => {

    const columns: DataTableColumn<Contact>[] = [
        {
            accessor: 'firstName',
            title: 'Name',
            ellipsis: true,
            render: (item) => {
                return (
                    <NavLink to={`/contacts/${item.id}`}>
                        <Text fw={700} fs={'sm'}>{item.firstName} {item.lastName}</Text>
                    </NavLink>
                )
            },
        },
        {
            accessor: 'email',
            title: 'Email',
            ellipsis: true,
            render: (item) => {
                return (
                    <Text fs={'sm'}>{item.email}</Text>
                )
            },
        },
        {
            accessor: 'company',
            title: 'Company',
            ellipsis: true,
            render: (item) => {
                return (
                    <Text fs={'sm'}>{item.company || 'n/a'}</Text>
                )
            },
        },
        {
            accessor: 'phone',
            title: 'Phone',
            ellipsis: true,
            render: (item) => {
                return (
                    <Text fs={'sm'}>{item.phone || 'n/a'}</Text>
                )
            },
        },
        {
            accessor: 'status',
            title: 'Status',
            render: (item) => {
                const colorMap: Record<string, string> = {
                    ACTIVE: 'green',
                    INACTIVE: 'gray',
                    DELETED: 'red',
                    ARCHIVED: 'orange',
                };
                return (
                    <Badge variant="light" color={colorMap[item.status || ''] || 'gray'}>
                        {item.status || 'n/a'}
                    </Badge>
                );
            },
        },
        {
            accessor: 'created',
            title: 'Created',
            render: (item) => formatTimestamp(item.created, 'MMM DD, YYYY'),
        }
    ];

    return {
        columns,
    };
};
